// hooks/useIsIphonePWA.ts
import { useState, useEffect } from 'react';

const useIsIphonePWA = () => {
    const [isIphonePWA, setIsIphonePWA] = useState(false);

    useEffect(() => {
        const ua = navigator.userAgent || window.opera;
        const isIPhone = /iPhone/i.test(ua);
        const isChrome = /CriOS/i.test(ua);
        const isStandalone =
            window.navigator.standalone === true ||
            window.matchMedia('(display-mode: standalone)').matches;

        const conditionMatched = isIPhone && (isStandalone || isChrome);
        setIsIphonePWA(conditionMatched);
    }, []);

    return isIphonePWA;
};

export default useIsIphonePWA;
